module.exports = __webpack_public_path__ + "static/media/coliseu_porto_ageas_circo_2019_04.99346d9a.jpg";